export const workspaceName = "FleetMinder";
